.outerBox {
  overflow: hidden;
  flex: 1;
}

.innerBox {
  flex: 1;
  overflow: hidden;
}

.scrollBox {
  overflow: auto;
  flex: 1;
  transform: translateZ(0);
}

.nonContainer {
  overflow: hidden;
  flex: 1;
  container-name: EntityChromeNonContainer;
}

.container {
  flex: 1;
  display: flex;
  flex-direction: column;
  container-name: EntityChromeContainer;
}
